export default __webpack_public_path__ + "static/media/site_impertinence.6a4893da.webp";